import React, { Component } from "react";
import { RadioBinary, RadioBinaryHeader } from "../../components/RadioBinary";
import { TextInput } from "../../components/BasicForm";
import { PrimaryFormNav } from "../../components/PrimaryFormNav";
import { RadioMultiButton } from "../../components/RadioMultiButton";
import { DateField } from "../../components/DateField";

class WorkHistory extends Component {
  state = {
    heading: "Your VADOC Work History",
    showProgressBar: true,
    pageId: "visitor-work-history"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handlePrevious = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  handleSubmit = fields => {
    const isErr = this.props.validateStep(fields);
    const stepData = this.props.stepData;

    if (!isErr) {
      this.props.nextStep(stepData);
    } else {
      this.scrollToError();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    let errFields = [];
    Object.keys(fields).map(fieldName => {
      if (fields[fieldName].className === "input-err") {
        errFields.push(fieldName);
      }
      return fieldName;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    firstErr.scrollIntoView();
  };
  render() {
    const fields = this.props.fields;
    return (
      <form
        className="visitation-form col-19"
        onSubmit={e => this.handleSubmit(Object.keys(fields))}
      >
        <RadioBinaryHeader posHeading="Yes" negHeading="No" />
        <RadioBinary
          legend={fields.eligibleRehire.legend}
          name="eligibleRehire"
          posId="y1"
          posVal="yes"
          negId="n1"
          negVal="no"
          errMessage={fields.eligibleRehire.errMessage}
          checkedVal={fields.eligibleRehire.value}
          handleBinaryChange={this.props.handleInputChange}
        />
        <RadioBinary
          legend={fields.meetOffender.legend}
          name="meetOffender"
          posId="y2"
          posVal="yes"
          negId="n2"
          negVal="no"
          errMessage={fields.meetOffender.errMessage}
          checkedVal={fields.meetOffender.value}
          handleBinaryChange={this.props.handleInputChange}
        />
        <fieldset>
          <RadioMultiButton
            legend={fields.employmentStatus.legend}
            fieldOpts={fields.employmentStatus.options}
            required={fields.employmentStatus.isRequired}
            fieldName="employmentStatus"
            checkedVal={fields.employmentStatus.value}
            errMessage={fields.employmentStatus.errMessage}
            handleMultiChange={this.props.handleInputChange}
          />
          <DateField
            value={fields.employmentStartDate.value}
            handleDateInput={this.props.handleDateInput}
            name="employmentStartDate"
            required={fields.employmentStartDate.isRequired}
            className={fields.employmentStartDate.className}
            formatDate={this.props.formatDate}
            parseDate={this.props.parseDate}
            errMessage={fields.employmentStartDate.errMessage}
            label={fields.employmentStartDate.label}
          />
          <DateField
            value={fields.employmentEndDate.value}
            handleDateInput={this.props.handleDateInput}
            name="employmentEndDate"
            required={fields.employmentEndDate.isRequired}
            className={fields.employmentEndDate.className}
            formatDate={this.props.formatDate}
            parseDate={this.props.parseDate}
            errMessage={fields.employmentEndDate.errMessage}
            label={fields.employmentEndDate.label}
          />
          <TextInput
            label={fields.employmentTitle.label}
            className={fields.employmentTitle.className}
            value={fields.employmentTitle.value}
            name="employmentTitle"
            required={fields.employmentTitle.isRequired}
            placeholder={fields.employmentTitle.placeholder}
            errMessage={fields.employmentTitle.errMessage}
            onChange={this.props.handleInputChange}
            id="employmentTitle"
          />
          <TextInput
            label={fields.employmentAlias.label}
            className={fields.employmentAlias.className}
            value={fields.employmentAlias.value}
            name="employmentAlias"
            placeholder={fields.employmentAlias.placeholder}
            errMessage={fields.employmentAlias.errMessage}
            onChange={this.props.handleInputChange}
            id="employmentAlias"
          />
          <TextInput
            label={fields.employmentLocation.label}
            className={fields.employmentLocation.className}
            value={fields.employmentLocation.value}
            name="employmentLocation"
            required={fields.employmentLocation.isRequired}
            placeholder={fields.employmentLocation.placeholder}
            errMessage={fields.employmentLocation.errMessage}
            onChange={this.props.handleInputChange}
            id="employmentLocation"
          />
        </fieldset>
        <PrimaryFormNav
          prevLabel="Step 1"
          nextLabel="Step 3"
          handlePrevious={this.handlePrevious}
          handleNext={this.handleSubmit}
          options={Object.keys(fields)}
        />
      </form>
    );
  }
}

export default WorkHistory;



// WEBPACK FOOTER //
// ./src/pages/WorkHistory/WorkHistory.js